import styled from "styled-components";
import { useState } from "react";
import {
    auth,
    googleProvider,
    facebookProvider,
} from "../../config/firebase.config";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [formError, setFormError] = useState(null);

    const handleLoginWithGoogle = async () => {
        try {
            await auth.signInWithPopup(googleProvider);
        } catch (error) {
            console.error("Google Sign-In Error:", error);
            setFormError(error.message);
        }
    };

    const handleLoginWithFacebook = async () => {
        try {
            await auth.signInWithPopup(facebookProvider);
        } catch (error) {
            console.error("Facebook Sign-In Error:", error);
            setFormError(error.message);
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setFormError(null);
        try {
            await auth.createUserWithEmailAndPassword(email, password);
            setPassword("");
            setEmail("");
        } catch (error) {
            if (
                error.message ===
                "Firebase: The email address is already in use by another account. (auth/email-already-in-use)."
            ) {
                try {
                    await auth.signInWithEmailAndPassword(email, password);
                    setPassword("");
                    setEmail("");
                } catch (error) {
                    setFormError(error.message.replace("Firebase:", ""));
                    setPassword("");
                }
            } else {
                setFormError(error.message.replace("Firebase:", ""));
                setPassword("");
            }
        }
    };

    return (
        <Container>
            <LoginForm>
                <Logo>
                    <LogoText>Fellora</LogoText>
                    <p>
                        A place to share knowledge and better understand the
                        world
                    </p>
                </Logo>
                <Form>
                    <LeftSection>
                        <LoginWith onClick={handleLoginWithGoogle}>
                            <svg
                                width="24"
                                height="24"
                                fillRule="evenodd"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    d="M20.16 12.193c0-.603-.054-1.182-.155-1.739H12v3.288h4.575a3.91 3.91 0 0 1-1.696 2.565v2.133h2.747c1.607-1.48 2.535-3.659 2.535-6.248h0z"
                                    fill="#4285f4"
                                ></path>
                                <path
                                    d="M12 20.5c2.295 0 4.219-.761 5.625-2.059l-2.747-2.133c-.761.51-1.735.811-2.878.811-2.214 0-4.088-1.495-4.756-3.504h-2.84v2.202C5.803 18.595 8.677 20.5 12 20.5h0z"
                                    fill="#34a853"
                                ></path>
                                <path
                                    d="M7.244 13.615A5.11 5.11 0 0 1 6.977 12a5.11 5.11 0 0 1 .267-1.615V8.183h-2.84C3.828 9.33 3.5 10.628 3.5 12s.328 2.67.904 3.817l2.84-2.202h0z"
                                    fill="#fbbc05"
                                ></path>
                                <path
                                    d="M12 6.881c1.248 0 2.368.429 3.249 1.271l2.438-2.438C16.215 4.342 14.291 3.5 12 3.5c-3.323 0-6.197 1.905-7.596 4.683l2.84 2.202C7.912 8.376 9.786 6.881 12 6.881h0z"
                                    fill="#ea4335"
                                ></path>
                            </svg>

                            <p>Continue with Google</p>
                        </LoginWith>
                        <LoginWith onClick={handleLoginWithFacebook}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    className="icon_svg-fill_as_stroke"
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M20.4995 11.9995C20.4995 7.30481 16.6937 3.49902 11.999 3.49902C7.30432 3.49902 3.49854 7.30481 3.49854 11.9995C3.49854 16.2423 6.60704 19.759 10.6708 20.3967V14.4567H8.51249V11.9995H10.6708V10.1267C10.6708 7.99631 11.9399 6.81952 13.8816 6.81952C14.8116 6.81952 15.7844 6.98555 15.7844 6.98555V9.07746H14.7125C13.6565 9.07746 13.3272 9.73271 13.3272 10.4049V11.9995H15.6848L15.3079 14.4567H13.3272V20.3967C17.391 19.759 20.4995 16.2423 20.4995 11.9995Z"
                                    fill="#1877F2"
                                ></path>
                            </svg>

                            <p>Continue with Facebook</p>
                        </LoginWith>
                        <SignUp>Sign up with Email</SignUp>
                        <Policy>
                            By continuing you indicate that you agree to Fellora’s
                            Terms of Service and Privacy Policy.
                        </Policy>
                    </LeftSection>
                    <RightSection>
                        <Title>Login / Signup</Title>
                        <Lable>Email</Lable>
                        <Input
                            type="text"
                            placeholder="Your Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <Lable>Password</Lable>
                        <Input
                            type="password"
                            placeholder="Your Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <FormError>{formError}</FormError>
                        <SubContained>
                            <ForgotPassword>Forgot password?</ForgotPassword>
                            <LoginButton type="submit" onClick={handleRegister}>
                                Login
                            </LoginButton>
                        </SubContained>
                    </RightSection>
                </Form>
                <Footer>
                    <Languages>
                        <span>English</span> <span>Español</span> <span>Français</span>
                    </Languages>
                    <About>
                        <p>
                            <span>About</span>・<span>Careers</span>・
                            <span>Privacy</span>・<span>Terms</span>・
                            <span>Contact</span>・<span>Languages</span>・
                            <span>Your Ad Choices</span>・<span>Press</span>・©
                            Fellora, Inc. 2026
                        </p>
                    </About>
                </Footer>
            </LoginForm>
        </Container>
    );
};

export default Login;

const Container = styled.div`
    width: 100%;
    min-height: 117vh;
    background: url("assets/login-img.png");
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: grid;
    place-items: center;
`;

const LoginForm = styled.div`
    width: 700px;
    max-width: 94%;
    min-height: 600px;
    border: 1px solid #e6e6e6;
    background: #fff;
    border-radius: 5px;
    /* background: #ffffff99; */

    @media (max-width: 700px) {
        width: 100%;
        max-width: 100%;
        min-height: auto;
        border-left: none;
        border-right: none;
        border-radius: 0;
    }
`;

const Logo = styled.div`
    text-align: center;
    margin-top: 15px;
    padding-bottom: 10px;

    p {
        font-weight: bold;
        color: #636466;
        font-size: 25px;
        margin-top: 6px;
    }
`;

const LogoText = styled.h1`
    font-family: 'Pacifico', cursive;
    font-size: 48px;
    color: #1DA1F2;
    letter-spacing: 1px;
    line-height: 1.1;
    margin-bottom: 4px;

    @media (max-width: 700px) {
        font-size: 38px;
    }
`;

const Form = styled.div`
    border-bottom: 1px solid #e6e6e6;
    height: 380px;
    display: flex;
    align-items: center;

    @media (max-width: 700px) {
        height: auto;
        flex-direction: column;
        align-items: stretch;
        padding: 20px 0 8px;
    }
`;

const RightSection = styled.div`
    /* border: 1px solid #e6e6e6; */
    width: 50%;
    height: 90%;
    padding: 0 25px;

    @media (max-width: 700px) {
        width: 100%;
        height: auto;
        padding: 0 25px;
    }
`;

const LeftSection = styled(RightSection)`
    border-right: 1px solid #e6e6e6;

    @media (max-width: 700px) {
        border-right: none;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
    }
`;

const LoginWith = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid #e6e6e6;
    padding: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 250ms;

    &:hover {
        background: #e6e6e645;
    }

    svg {
        transform: scale(1.1);
        margin-right: 10px;
        cursor: pointer !important;
    }

    p {
        font-weight: 400;
        font-size: 25px;
        color: #282829;
        cursor: pointer;
    }
`;

const SignUp = styled.div`
    text-align: center;
    font-size: 25px;
    font-weight: 500;
    color: #636466;
    padding: 7px;
    border-radius: 20px;
    cursor: pointer;
    position: relative;
    margin-bottom: 20px;
    transition: all 250ms;

    &:hover {
        background: #e6e6e645;
    }

    &:after {
        content: "";
        position: absolute;
        width: 100%;
        border-bottom: 1px solid #e6e6e6;
        left: 0;
        bottom: -10px;
        cursor: default;
    }
`;

const Policy = styled.p`
    color: #939598;
    font-size: 16px;
    width: 95%;
    line-height: 1.3;
`;

const Title = styled.p`
    font-size: 25px;
    font-weight: 500;
    padding: 3px 0 10px 0;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 20px;
`;

const Lable = styled.p`
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 5px;
    padding-left: 1.5px;
`;

const Input = styled.input`
    width: 100%;
    height: 52px;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    margin-bottom: 25px;
    padding: 0 10px;
    font-size: 20px;
    color: #282829;
    transition: all 250ms;

    &:hover,
    &:active {
        border: 1px solid blue;
        outline: none;
    }
    &:focus {
        border: 1px solid blue;
        outline: none;
    }
`;

const FormError = styled.div`
    color: red;
    font-size: 10px;
    margin-top: -20px;
    margin-bottom: 20px;
`;

const SubContained = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: -10px;

    @media (max-width: 700px) {
        flex-wrap: wrap;
        gap: 8px;
    }
`;

const LoginButton = styled.button`
    width: 34%;
    height: 48px;
    border: none;
    border-radius: 40px;
    background: #1DA1F2;
    opacity: 1;
    color: #fff;
    font-weight: bold;
    font-size: 25px;
    transition: all 250ms;
    cursor: pointer;

    &:hover {
        background: #0d8ecf;
        opacity: 1;
    }

    @media (max-width: 700px) {
        width: 100%;
        font-size: 22px;
    }
`;

const ForgotPassword = styled.p`
    font-size: 25px;
    color: #939598;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    padding-left: 2px;
`;

const Footer = styled.div`
    height: 117px;
`;

const Languages = styled.div`
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: darkblue;
    font-size: 14px;
    font-weight: 300;

    span {
        margin-left: 30px;
        position: relative;
        cursor: pointer;

        &:after {
            content: "❯";
            position: absolute;
            font-size: 16px;
            color: black;
            opacity: 0.5;
            right: -15px;
            cursor: default;
        }
    }
`;

const About = styled.div`
    height: 50%;
    border: 1px solid #e9e9e9;
    background: #e3e3e380;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #282829;
    opacity: 0.8;

    & p span {
        position: relative;
        cursor: pointer;
    }
    & p span::after {
        content: "";
        width: 100%;
        position: absolute;
        border-bottom: 1px solid #282829;
        left: 0;
        bottom: 0;
        opacity: 0;
        transition: all 250ms;
    }

    & p span:hover::after {
        opacity: 1;
    }
`;
